<template>
  <div class="sorting">
    <span v-if="!display.smAndDown">Сортировать:</span>
    <div v-for="sort in initState" :key="sort.id">
      <template v-if="sort.direction">
        <div class="btn-container">
          <Button
            :classes="['sorting__btn', sort.selected && 'sorting__btn--active']"
            :onClick="() => toogle(sort.id, sort.direction)"
            text
          >
            {{ sort.name }}</Button
          >
          <ArrowNextIcon
            class="sorting__icon"
            :class="[
              sort.direction === 'asc' && 'sorting__icon--desc',
              sort.selected && 'sorting__icon--active'
            ]"
          />
        </div>
      </template>
      <template v-else>
        <Button
          :classes="['sorting__btn', sort.selected && 'sorting__btn--active']"
          :onClick="() => toogle(sort.id)"
          text
        >
          {{ sort.name }}
        </Button>
      </template>
    </div>
  </div>
</template>
<script>
import { ref } from '@vue/composition-api'
import { useDisplay } from '@/hooks'

import ArrowNextIcon from '@/assets/icons/arrow-next'
import Button from '@/components/button'

export default {
  name: 'main-sorting',
  components: { Button, ArrowNextIcon },
  props: ['initState'],
  setup() {
    const display = useDisplay()
    const selectSort = ref()

    function toogle(id, dir) {
      if (!dir) {
        this.$emit('update', id)
      } else {
        const direction = dir === 'asc' ? 'desc' : 'asc'
        this.$emit('update', id, direction)
      }
    }

    return {
      selectSort,
      toogle,
      display
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'style';
</style>
